import styled from "styled-components";

const LED_COUNT = 10;

const ledColors = [
	"#22c55e",
	"#22c55e",
	"#22c55e",
	"#84cc16",
	"#84cc16",
	"#eab308",
	"#eab308",
	"#f97316",
	"#ef4444",
	"#dc2626",
];

const Styles = {
	Frame: styled.div`
		display: inline-flex;
		align-items: center;
		gap: 4px;
		padding: 6px;
		background: #05070a;
		border: 1px solid rgba(255, 255, 255, 0.16);
		border-radius: 6px;
		box-shadow:
			inset 0 0 10px rgba(0, 0, 0, 0.85),
			0 0 10px rgba(0, 0, 0, 0.35);
	`,

	Led: styled.div<{ $active: boolean; $color: string }>`
		width: 6px;
		height: 14px;
		border-radius: 2px;
		background: ${({ $active, $color }) => ($active ? $color : "#111827")};
		border: 1px solid ${({ $active, $color }) => ($active ? $color : "#1f2937")};
		opacity: ${({ $active }) => ($active ? 1 : 0.28)};
		box-shadow: ${({ $active, $color }) =>
		$active
			? `
					0 0 6px ${$color},
					0 0 14px ${$color},
					inset 0 1px 2px rgba(255, 255, 255, 0.45)
				`
			: "inset 0 1px 2px rgba(255, 255, 255, 0.08)"};
		transition:
			background 80ms linear,
			border-color 80ms linear,
			opacity 80ms linear,
			box-shadow 80ms linear;
	`,
};

type VolumeIndicatorProps = {
	volume: number;
};

export const VolumeIndicator = ({ volume }: VolumeIndicatorProps) => {

	const normalizedVolume = Math.max(0, Math.min(100, volume));
	const activeLeds = Math.ceil((normalizedVolume / 100) * LED_COUNT);

	return (
		<Styles.Frame
			role="meter"
			aria-label="Lautstärke"
			aria-valuemin={0}
			aria-valuemax={100}
			aria-valuenow={normalizedVolume}
		>
			{Array.from({ length: LED_COUNT }).map((_, index) => (
				<Styles.Led
					key={index}
					$active={index < activeLeds}
					$color={ledColors[index]}
				/>
			))}
		</Styles.Frame>
	);
};